import { Directive, Input, inject } from '@angular/core';
import { Product } from '@df/catalog/product/product';
import { NgInject } from '@df/ng/ng-inject';
import { App } from '@df/core/app';
import { AbstractGtmTrack } from '@df/module-gtm/abstract-gtm-track';
import { Gtm } from '@df/module-gtm/gtm.namespace';

@Directive()
export abstract class GtmImpressionTrackDirectiveDef extends AbstractGtmTrack<Gtm.ITrackImpressionData> {
    @Input()
    gtmImpressionTrack?: Gtm.ITrackImpressionData;

    private app = inject(App);

    sendEvent(): void {
        const impression = this.getData();

        if (impression) {
            const productId = impression.productId;

            if (productId) {
                this.app.resources.product.load(productId, 2).then(() => {
                    const product = this.app.resources.product.get(productId);

                    this.updateImpression(product, impression);
                });
            }
        }
    }

    updateImpression(product: Product | undefined, impression: Gtm.ITrackImpressionData): void {
        const productImpression = this.gtmService.toProductData(product);

        if (productImpression && !this.sent) {
            productImpression.position = impression.position;
            productImpression.list = impression.list || this.gtmService.getDefaultListName();

            this.gtmService.trackImpressionsBuffered([productImpression]);
            this.sent = true;
        }
    }

    getData(): Gtm.ITrackImpressionData | undefined {
        return this.gtmImpressionTrack;
    }
}
